import { DateConverter } from '@/model/converters/datesConverters';
import { CustomConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class ReglementCommande {
  constructor (
    modeReglement?: string,
    numDomiciliationBancaire?: number,
    codeBic?: string,
    iban?: string,
    tauxEscompte?: number,
    prixUnitaireHT?: number,
    prixUnitaireTTC?: number,
    montantTotalHT?: number,
    montantTotalTTC?: number,
    dateEcheance?: Date
  ) {
    this.modeReglement = modeReglement as any;
    this.numDomiciliationBancaire = numDomiciliationBancaire as any;
    this.codeBic = codeBic as any;
    this.iban = iban as any;
    this.tauxEscompte = tauxEscompte as any;
    this.prixUnitaireHT = prixUnitaireHT as any;
    this.prixUnitaireTTC = prixUnitaireTTC as any;
    this.montantTotalHT = montantTotalHT as any;
    this.montantTotalTTC = montantTotalTTC as any;
    this.dateEcheance = dateEcheance as any;
  }

  @JsonProperty(String)
  modeReglement?: string;

  @JsonProperty(String)
  @Optional
  numDomiciliationBancaire?: string;

  @JsonProperty(String)
  @Optional
  codeBic?: string;

  @JsonProperty(String)
  @Optional
  iban?: string;

  @JsonProperty(Number)
  tauxEscompte?: number;

  @JsonProperty(Number)
  @Optional
  prixUnitaireHT?: number;

  @JsonProperty(Number)
  @Optional
  prixUnitaireTTC?: number;

  @JsonProperty(Number)
  @Optional
  montantTotalHT?: number;

  @JsonProperty(Number)
  @Optional
  montantTotalTTC?: number;

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  dateEcheance?: Date;
}
